import React from 'react'
import Accordion from 'react-bootstrap/Accordion'

function FaqTechDigit() {
    const faqs = [
        {
            q: 'What is TechDigit Solutions?',
            a: 'TechDigit Solutions is a US-focused technology and outsourcing company founded in 2020. It provides medical billing and revenue cycle management for healthcare providers, managed cybersecurity services for businesses across all industries, call center and customer support outsourcing for businesses that communicate with customers and professional ebook and whitepaper writing services for companies and authors in any sector.',
        },
        {
            q: 'Who does TechDigit Solutions work with?',
            a: 'TechDigit works with US healthcare providers across all specialties for billing and call center services. Its cybersecurity practice serves businesses of any size across any industry. Its content writing services support technology companies, financial firms, professional services organizations, coaches, consultants, and authors across all genres.',
        },
        {
            q: 'Is TechDigit Solutions only for healthcare companies?',
            a: 'No. Medical billing is healthcare-specific. However, cybersecurity, call center outsourcing, and content writing services are available to businesses across all industries, including technology, finance, legal, retail, education, manufacturing, publishing and more.',
        },
        {
            q: 'Is TechDigit Solutions HIPAA compliant?',
            a: 'Yes. Every team member is fully HIPAA-certified before handling any client data. All processes are documented, auditable and built with data privacy as the foundation.',
        },
        {
            q: 'When was TechDigit Solutions founded?',
            a: 'TechDigit Solutions was founded in 2020 by four professionals with backgrounds in healthcare IT and operations.',
        },
        {
            q: 'How quickly can TechDigit Solutions start delivering results?',
            a: 'Most clients are fully operational within 2 to 4 weeks of engagement, depending on the service and complexity of the implementation.',
        },
        {
            q: 'What makes TechDigit Solutions different from other outsourcing companies?',
            a: 'Every client gets a dedicated team not rotating agents. Direct access to leadership not a ticket system. Monthly performance reporting with real metrics. And a 95-plus percent client retention rate built entirely on results not lock-in contracts.',
        },
    ]
    return (
        <div className="faq-techdigit td-section td-section--faq rts-faq-section rts-section-gap">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-9">
                        <div className="faq-techdigit-inner">
                            <div className="td-section-head text-center mb-5">
                                <p className="td-section-label">FAQ</p>
                                <h2 className="td-section-title">Questions People Ask About TechDigit Solutions</h2>
                                <div className="td-title-rule td-title-rule--center mx-auto" aria-hidden="true" />
                            </div>
                            <div className="faq-accordion-area">
                                <Accordion defaultActiveKey="0">
                                    {faqs.map((faq, i) => (
                                        <Accordion.Item key={i} eventKey={String(i)}>
                                            <Accordion.Header>{faq.q}</Accordion.Header>
                                            <Accordion.Body>{faq.a}</Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FaqTechDigit
